import { render, staticRenderFns } from "./addAirport.vue?vue&type=template&id=b32a1ab6&scoped=true&"
import script from "./addAirport.vue?vue&type=script&lang=ts&"
export * from "./addAirport.vue?vue&type=script&lang=ts&"
import style0 from "./addAirport.vue?vue&type=style&index=0&id=b32a1ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32a1ab6",
  null
  
)

export default component.exports